import breakpoints from '../style/base/breakpoints.less';
export default breakpoints;
